import http from "@/settings/apiSettings"

class PORTAL_DashboardService {
  get(): Promise<any> {
    return http.clientPortalHR.get("/portal/dashboard", {
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
    });
  }
}

export default new PORTAL_DashboardService();
